import { render, staticRenderFns } from "./ReturnsCounter.vue?vue&type=template&id=7d255322&scoped=true&"
import script from "./ReturnsCounter.vue?vue&type=script&lang=js&"
export * from "./ReturnsCounter.vue?vue&type=script&lang=js&"
import style0 from "./ReturnsCounter.vue?vue&type=style&index=0&id=7d255322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d255322",
  null
  
)

export default component.exports